// src/components/Footer/FooterBottom.js

const FooterBottom = () => {
  return (
    <div className="footer-bottom">
      <p className="footer-copyright">
        © 2026 803Tree.com. All rights reserved.
      </p>
    </div>
  );
};

export default FooterBottom;